import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiMail, FiPhone, FiMapPin, FiInstagram, FiClock } from 'react-icons/fi';
import { FaWhatsapp, FaTiktok } from 'react-icons/fa';
import './Contact.css';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section 
      className="contact section" 
      id="contact"
      style={{ backgroundImage: 'url(/iletisim.jpeg)' }}
    >
      <div className="contact-overlay"></div>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="section-title">{t('contact.title')}</h2>
          <p className="section-subtitle">{t('contact.subtitle')}</p>
        </motion.div>

        <motion.div 
          className="contact-wrapper contact-no-video"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* İletişim Bilgileri */}
          <div className="contact-info-card">
            <h3>{t('contact.info')}</h3>
            
            <div className="info-item">
              <div className="info-icon">
                <FiMapPin />
              </div>
              <div className="info-content">
                <strong>{t('contact.address')}</strong>
                <p>İlkbahar Mah. Sinpaş Altınoran Sitesi Kule 3 No: 196, Çankaya/Ankara</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FiPhone />
              </div>
              <div className="info-content">
                <strong>{t('contact.phone')}</strong>
                <a href="tel:+905337757181">+90 (533) 775 71 81</a>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FiClock />
              </div>
              <div className="info-content">
                <strong>{t('contact.workingHours')}</strong>
                <p>10:00 - 18:00</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <FiMail />
              </div>
              <div className="info-content">
                <strong>{t('contact.email')}</strong>
                <a href="mailto:info@ustaconsulting.com">info@ustaconsulting.com</a>
              </div>
            </div>

            <a 
              href="https://wa.me/905337757181" 
              target="_blank" 
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              <FaWhatsapp />
              {t('contact.whatsappBtn')}
            </a>

            <div className="social-links">
              <h4>{t('contact.followUs')}</h4>
              <div className="social-icons">
                <a href="https://www.instagram.com/ustaconsulting" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FiInstagram />
                </a>
                <a href="https://www.tiktok.com/@ustaconsulting" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                  <FaTiktok />
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;

